import { renderToStaticMarkup } from "react-dom/server";

export const convertSvgToBase64Uri = (svg) => {
  const svgString = encodeURIComponent(renderToStaticMarkup(svg));
  const dataUri = `url("data:image/svg+xml,${svgString}")`;

  return dataUri;
};
